import {useContext} from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { ErrorContexts } from '../../contexts/ErrorContext'
import errorCodes from '../../utils/errorCodes'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
}

function ErrorFallback() {
  const {error, setError} = useContext(ErrorContexts)
  const message = errorCodes[error] ||  error?.message || 'Error desconocido'

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={true}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={true}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <ErrorOutlineOutlinedIcon /> Error
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              ¡Ups! Algo salió mal.
              <br />
              <small>Error:{message}</small>
            </Typography>
            <Button
              variant="outlined"
              onClick={() => setError(null)}
              color="error"
              size="small"
            >
              Aceptar
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default ErrorFallback
